import { inject, Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AuthService } from "../Services/auth/auth.service";
import { catchError, map, Observable, of } from "rxjs";
import { StateService } from "../Services/state/state.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  stateService = inject(StateService);
  authService = inject(AuthService);
  router = inject(Router);

  constructor() {}

  canActivate(): Observable<boolean> {
    return this.authService.validateSession().pipe(
      map((sessionIsValid) => {
        if (sessionIsValid) {
          return true;
        } else {
          this.router.navigate(["/login"], {
            replaceUrl: true,
            queryParams: { logoutCause: "session end" },
          });
          this.stateService.clearUser();
          return false;
        }
      }),
      catchError(() => {
        this.router.navigate(["/login"], {
          replaceUrl: true,
          queryParams: { logoutCause: "session end" },
        });
        this.stateService.clearUser();
        return of(false);
      })
    );
  }
}
